import React from 'react';
import RoundedButton from 'components/RoundedButton';

const CSS = require('./SubmitButton.less');

interface SubmitButtonProps {
  onSubmit?: (event) => void;
  text: string;
  'data-test-id'?: string;
  loading?: boolean;
  disabled?: boolean;
}

function SubmitButton({ onSubmit, text, loading, disabled, 'data-test-id': dataTestId }: SubmitButtonProps) {
  return (
    <div className={CSS.Submit}>
      <RoundedButton pink edgeRounding="medium" data-test-id={dataTestId} type="submit" onClick={onSubmit} className={CSS.SubmitButton} isLoading={loading} disabled={disabled}>
        <span className={CSS.SubmitText}>{text}</span>
      </RoundedButton>
    </div>
  );
}

export default SubmitButton;
